(() => {
  'use strict';

  // --- SELECTORS & CLASSES ---
  const SEL = {
    quickViewSizeBtn: '.quick-modal-size-btn',
    quickViewAddToCart: '.quick-modal-add-to-cart',
    quickViewError: '.quick-modal-size-error',
    quickViewModal: '.product-quick-modal',
    cartMessage: '.video-cart-message'
  };

  const CLASSES = {
    selected: 'selected',
    loading: 'is-loading',
    success: 'is-success',
    error: 'is-error',
    active: 'active'
  };

  const $ = (selector, context = document) => context.querySelector(selector);
  const $all = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  // --- SHOW CART SUCCESS MESSAGE ---
  const showCartSuccessMessage = () => {
    const msg = document.querySelector(SEL.cartMessage);
    if (!msg) return;

    msg.style.display = 'flex';
    msg.classList.add(CLASSES.active);

    const btn = msg.querySelector('.video-cart-message-btn');
    if (btn && !btn._bound) {
      btn._bound = true;
      btn.addEventListener('click', () => {
        // Open cart drawer instead of redirecting
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else if (drawer && drawer.classList) {
            drawer.setAttribute('open', '');
        } else {
          // Dispatch custom event for cart drawer
          document.dispatchEvent(new CustomEvent('cart:open-drawer'));
        }
      });
    }

    setTimeout(() => {
      msg.classList.remove(CLASSES.active);
      msg.style.display = 'none';
    }, 2000);
  };

  // --- ADD TO CART FUNCTION ---
  const addToCart = async (variantId, buttonEl) => {
    if (!variantId || !buttonEl) return;

    const atcActionId = window.atcTracking?.begin({
      source: buttonEl.dataset.atcSource || "quick_view",
      items: [{ id: variantId, quantity: 1 }],
    });

    buttonEl.classList.add(CLASSES.loading);
    buttonEl.setAttribute('aria-disabled', 'true');
    buttonEl.disabled = true;
    const originalText = buttonEl.textContent;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      let data;
      try {
        data = await response.json();
      } catch {
        throw new Error('Unexpected server response');
      }

      if (!response.ok) throw new Error(data.description || 'Failed to add item to cart.');

      buttonEl.classList.remove(CLASSES.loading);
      buttonEl.classList.add(CLASSES.success);

      // ✅ Show the success message overlay
      showCartSuccessMessage();

      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: data } }));

    } catch (error) {
      console.error('Add to cart error:', error);
      buttonEl.classList.remove(CLASSES.loading);
      buttonEl.classList.add(CLASSES.error);
      buttonEl.textContent = 'Error';
    } finally {
      window.atcTracking?.complete(atcActionId);
      setTimeout(() => {
        buttonEl.classList.remove(CLASSES.success, CLASSES.error);
        buttonEl.removeAttribute('aria-disabled');
        buttonEl.disabled = false;
        buttonEl.textContent = originalText;
      }, 2000);
    }
  };

  // --- VARIANT SELECTION LOGIC ---
  document.addEventListener('click', (e) => {
    const overlayAtc = e.target.closest('.add-to-cart-overlay');
    if (overlayAtc && !overlayAtc.disabled) {
      const handle = overlayAtc.dataset.productHandle;
      if (handle) {
        fetch(`/products/${handle}.json`)
          .then((response) => response.json())
          .then((data) => {
            const variant = (data?.product?.variants || []).find((item) => item.available) || data?.product?.variants?.[0];
            if (variant) {
              overlayAtc.dataset.atcSource = 'video_widget';
              addToCart(variant.id, overlayAtc);
            }
          })
          .catch(() => {});
      }
      return;
    }

    // Select size
    const sizeOptionBtn = e.target.closest(SEL.quickViewSizeBtn);
    if (sizeOptionBtn) {
      const modal = sizeOptionBtn.closest(SEL.quickViewModal);

      $all(SEL.quickViewSizeBtn, modal).forEach(btn => btn.classList.remove(CLASSES.selected));
      sizeOptionBtn.classList.add(CLASSES.selected);

      modal.dataset.selectedVariantId = sizeOptionBtn.dataset.variantId;

      const errorMsg = $(SEL.quickViewError, modal);
      if (errorMsg) errorMsg.style.display = 'none';

      const addToCartBtn = $(SEL.quickViewAddToCart, modal);
      if (sizeOptionBtn.disabled) {
        addToCartBtn.textContent = 'Sold Out';
        addToCartBtn.disabled = true;
      } else {
        addToCartBtn.textContent = 'Add to cart';
        addToCartBtn.disabled = false;
      }
      return;
    }

    // Add to cart from Quick View
    const quickViewAddToCart = e.target.closest(SEL.quickViewAddToCart);
    if (quickViewAddToCart) {
      const modal = quickViewAddToCart.closest(SEL.quickViewModal);
      const variantId = modal.dataset.selectedVariantId;
      const hasSizeOptions = modal.querySelectorAll(SEL.quickViewSizeBtn).length > 0;

      if (hasSizeOptions && !variantId) {
        const errorMsg = $(SEL.quickViewError, modal);
        if (errorMsg) errorMsg.style.display = 'block';
        return;
      }

      const defaultVariantInput = modal.querySelector('input[name="id"]');
      const finalVariantId = variantId || defaultVariantInput?.value;

      if (finalVariantId && !quickViewAddToCart.disabled) {
        quickViewAddToCart.dataset.atcSource = 'quick_view';
        addToCart(finalVariantId, quickViewAddToCart);
      }
      return;
    }
  });

  // --- VIEWPORT HEIGHT FIX ---
  function updateVhUnit() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  window.addEventListener('resize', updateVhUnit);
  window.addEventListener('orientationchange', updateVhUnit);
  updateVhUnit();

})();
